"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterMenuByMerchantType = exports.default = void 0;
var menuConfig = {
  1: {
    name: "电商商户",
    menuKeywords: [],
    whiteRouteList: ["/dashboard", "/product", "/order", "/user", "/design", "/marketing", "/staff", "/finance", "/operation", "/maintain", "/operation/logisticsManagement",
    // ✅ 电商独有
    "/operation/freightSet", "/operation/businessAddress"]
  },
  10: {
    name: "酒店商户",
    menuKeywords: ["hotel"],
    whiteRouteList: ["/hotel", "/dashboard", "/order", "/user", "/staff", "/finance", "/operation", "/maintain", "/property"]
  },
  20: {
    name: "餐饮商户",
    menuKeywords: ["canteen"],
    whiteRouteList: ["/canteen-product", "/dashboard", "/order", "/user", "/staff", "/finance", "/maintain", "/operation"]
  },
  30: {
    name: "门票商户",
    menuKeywords: ["scenic-spot"],
    whiteRouteList: ["/scenic-spot", "/dashboard", "/order", "/user", "/staff", "/finance", "/ticketing", "/maintain", "/operation"]
  },
  40: {
    name: "活动商户",
    menuKeywords: ["activity"],
    whiteRouteList: ["/dashboard", "/activity-product", "/order", "/user", "/design", "/staff", "/finance", "/maintain", "/operation"]
  }
};
var filterMenuByMerchantType = exports.filterMenuByMerchantType = function filterMenuByMerchantType(menuType, menuList) {
  var config = menuConfig[menuType];
  if (!config) return menuList;
  var _config$whiteRouteLis = config.whiteRouteList,
    whiteRouteList = _config$whiteRouteLis === void 0 ? [] : _config$whiteRouteLis,
    _config$menuKeywords = config.menuKeywords,
    menuKeywords = _config$menuKeywords === void 0 ? [] : _config$menuKeywords;
  var whiteSubMenus = {
    1: ['/operation/logisticsManagement', '/operation/freightSet'],
    10: [],
    20: [],
    30: [],
    40: []
  };
  var allowSubNames = whiteSubMenus[menuType] || [];
  var filterFn = function filterFn(menu) {
    var isInWhiteList = whiteRouteList.includes(menu.path);
    var isInKeywords = menuKeywords.length && menuKeywords.some(function (k) {
      return menu.path.includes(k);
    });

    // ✅ 仅电商商户才对 /operation 下的子菜单进行过滤
    if (menu.children && menu.children.length && menuType === 1 && menu.path === '/operation') {
      menu.children = menu.children.filter(function (child) {
        return allowSubNames.includes(child.name) || !child.name;
      });
    }
    return isInWhiteList || isInKeywords;
  };
  return menuList.filter(filterFn);
};
var _default = exports.default = menuConfig;